export default __webpack_public_path__ + "static/media/logo.d2282827.svg";